<template>
    <v-container class="fill-height">
        <v-row justify="center" align="center">
            <v-col
                    cols="12"
                    sm="8"
                    md="6">
                <v-card>
                    <v-card-title>
                        У вас нет доступа
                    </v-card-title>
                    <v-card-subtitle>
                        Для участия в закупка вы должны состоять в группе!
                    </v-card-subtitle>
                    <v-card-text class="text-center">
                        <div>
                            <v-avatar size="150">
                                <v-img :src="auth_info.profile_image"></v-img>
                            </v-avatar>
                        </div>
                        Вы авторизовались как<br><strong>{{auth_info.user.first_name}}
                        {{auth_info.user.last_name}}</strong>
                        <div class="my-2">
                            <v-btn small class="btn" color="primary" @click="goTo(auth_info.provider)">
                                Сменить аккаунт
                            </v-btn>
                        </div>
                        <a style="text-decoration: unset; color: gray;" @click="goToAuth">
                            Вернуться к авторизации
                        </a>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapActions, mapState} from "vuex";

    export default {
        name: "AccessDenied",
        computed: {
            ...mapState('auth', [
                'auth_info'
            ])
        },
        methods: {
            ...mapActions('auth', [
                'logout'
            ]),
            goToAuth() {
                this.logout().then(() => {
                    location.replace('/')
                })
            },
            goTo(provider) {
                switch (provider) {
                    case 'vk-oauth2': {
                        this.logout().then(() => {
                            location.replace('https://vk.com/')
                        })
                        break
                    }
                    case 'odnoklassniki-oauth2': {
                        this.logout().then(() => {
                            location.replace('https://ok.ru/')
                        })
                    }
                }
            }
        },
        mounted() {
            if (this.auth_info.user === undefined) {
                this.logout().then(() => location.replace('/'));
            }
        }
    }
</script>

<style scoped>

</style>